// RBAC map from docs/analytics-dashboard-strategy.md §7, as a plain lookup.
// This is a rendering aid only — never a security boundary. The real boundary is
// enforced server-side in FastAPI, once these pages are wired to real APIs.

export const ROLES = ["master", "gm", "wm", "ccm", "psf", "receptionist", "sa"];

// Scope values: 'all' | 'workshop' | 'own' | 'readonly' | 'count' | false (no access)
// No "floor" key anymore — Live Status is retired. Customer Approval Pending, Pending
// Response, and Escalations are reached via cards on Overview, scoped the same way the
// rest of that page is, rather than being their own nav-gated pages.
export const ROLE_VIEWS = {
  // analytics: 'all' is every workshop; 'workshop' is own workshop(s) only.
  // Mirrors ANALYTICS_ROLES in apps/api/analytics.py, which enforces it.
  // complaints: 'manage' can move a complaint's stage on the Journey page; 'read' only sees
  // it. Mirrors COMPLAINT_MANAGE_ROLES in apps/api/server.py, which enforces it.
  master: {
    pages: { overview: "all", jobcards: "all", notifications: true, journey: "all", chatHistory: "all", create: true, stakeholders: "edit", regions: "edit", users: true, desk: true, analytics: "all", complaints: "manage", systemHealth: true },
  },
  gm: {
    pages: { overview: "all", jobcards: "all", notifications: true, journey: "all", chatHistory: "all", create: true, stakeholders: "read", users: false, analytics: "all", complaints: "manage", systemHealth: true },
  },
  wm: {
    pages: { overview: "workshop", jobcards: "workshop", notifications: true, journey: "workshop", chatHistory: "workshop", create: true, stakeholders: "read", users: false, analytics: "workshop", complaints: "manage", systemHealth: true },
  },
  ccm: {
    pages: { overview: "workshop", jobcards: "workshop", notifications: true, journey: "workshop", chatHistory: "workshop", create: true, stakeholders: "read", users: false, analytics: "workshop", complaints: "manage" },
  },
  psf: {
    pages: { overview: "workshop", jobcards: "count", notifications: false, journey: "workshop", chatHistory: "workshop", create: false, stakeholders: false, users: false, analytics: false, complaints: "read" },
  },
  receptionist: {
    pages: { overview: false, jobcards: "count", notifications: false, journey: "workshop", chatHistory: "workshop", create: true, stakeholders: false, users: false, analytics: false, complaints: "read" },
  },
  sa: {
    pages: { overview: "own", jobcards: "own", notifications: false, journey: "own", chatHistory: "own", create: true, stakeholders: false, users: false, desk: true, analytics: "own", complaints: "read" },
  },
};

export function canSee(role, page) {
  return !!ROLE_VIEWS[role]?.pages?.[page];
}

export function scopeFor(role, page) {
  return ROLE_VIEWS[role]?.pages?.[page] ?? false;
}

// The demo identity switcher's per-role controls (Appendix D).
// locationControl: 'hidden' | 'multi' | 'single'
export const IDENTITY_CONTROL = {
  master: { locationControl: "hidden", needsAdvisor: false },
  gm: { locationControl: "multi", needsAdvisor: false },
  wm: { locationControl: "single", needsAdvisor: false },
  ccm: { locationControl: "single", needsAdvisor: false },
  psf: { locationControl: "single", needsAdvisor: false },
  receptionist: { locationControl: "single", needsAdvisor: false },
  sa: { locationControl: "single", needsAdvisor: true },
};

export const ROLE_LABEL = {
  master: "Master",
  gm: "GM",
  wm: "WM",
  ccm: "CCM",
  psf: "PSF",
  receptionist: "Receptionist",
  sa: "SA",
};
